<template>
    <div>
        <div class="row" v-if="field">

          <b-carousel
              :interval="4000"
              controls
              indicators
              id="carousel-1"
          >
            <b-carousel-slide v-for="(img, index) in field.images" v-bind:key="index" v-bind:index="index" :img-src="img"></b-carousel-slide>
          </b-carousel>

            <div class="">
                <h2>{{field.name}}</h2>
                <p>
                    {{field.description}}
                </p>
                <strong>
                    Kosten pro Stunde: {{formatPrice(field.pricePerHour)}}
                </strong>
                <div>
                    {{field.address}}<br>
                    {{field.plz}}
                </div>
                <div>
                    <strong>Eigentümer:</strong> {{field.owner ? field.owner.name : ''}}
                </div>
            </div>
        </div>
        <b-card-group v-if="field">

            <b-card>
                <b-card-title>Öffnungszeiten</b-card-title>
                <b-list-group>
                    <b-list-group-item v-for="entry in field.openHours" v-bind:key="entry.day.id" class="d-flex justify-content-between align-items-center">
                        {{entry.day.name}}
                        <div>
                            <span v-for="(hour, index) in entry.hours" v-bind:key="index">{{index > 0 ? ' & ':''}}{{hour.start}}-{{hour.end}}</span>
                        </div>
                    </b-list-group-item>
                </b-list-group>

            </b-card>
            <b-card>
                <b-card-title>Rezension</b-card-title>

                <b-card-text>Rate 10/10 would do again</b-card-text>
            </b-card>
        </b-card-group>
    </div>
</template>

<script>

    import {fieldService} from "../services/field.service";
    import {utilsService} from "../services/utils.service";

    export default {
        name: 'FieldDetail',
        data() {
            return {
                field: {}
            }
        },
      props:{
          id: Number
      },
        created() {
            /*this.id = this.$route.params.id;*/
            this.getField()
        },
        methods: {
            getField() {
                fieldService.getField(this.id).then(res => {
                    this.field = res;
                  console.log(this.id);
                  console.log(this.field);
                });
            },
            formatPrice(priceInCent) {
                const priceInEuro = priceInCent / 100;
                return utilsService.formatCurrency(priceInEuro);
            },
            foo() {
                console.log('worked')
            }
        }
    }
</script>

<style scoped>

</style>
